const ort = (touched=null) => {
    return {
        zoomIn: {
            value:true,
        },
        meta:{
            touched: touched,
            valid:null,
        },
        strasse:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        hausnummer:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        adresszusatz:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        plz:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        plzVorschlagsliste:{
            value: [
            ],
            touched: touched,
            valid:null,
            required:true,
            msg:'',
            display:true,

        },
        ort:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        }
    }
}
export default ort;